import axios from "axios";
import authentication from "@/authentication";
export default {
  baseUrl: process.env.VUE_APP_API_CALAMITY_SERVICE_BASE,
  async create(calamity) {
    await authentication.isAuthenticated();
    return axios
      .post(`${this.baseUrl}/Create`, JSON.stringify(calamity), {
        headers: { Authorization: `Bearer ${authentication.getToken()}` }
      })
      .then(response => {
        return response.data;
      });
  },
  async loadPotential() {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/GetPotential`, {
        headers: { Authorization: `Bearer ${authentication.getToken()}` }
      })
      .then(response => {
        return response.data;
      });
  },
  async loadPotentialPackages(hashKey) {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/GetPotentialPackages?hashKey=${hashKey}`, {
        headers: { Authorization: `Bearer ${authentication.getToken()}` }
      })
      .then(response => {
        return response.data;
      });
  }
};
